package uz.ferro.shop.pages.admin.debt.model

import kotlinx.serialization.Serializable

@Serializable
data class DebtFilter(
    val businessPartnerId: String? = null,
    val minSaldo: Double? = null,
    val maxSaldo: Double? = null,
    val dueDate: String? = null,
    val salesPointId: String? = null,
)